import { Text, Tooltip } from '@/design-system';
import { xCount } from '@/utils/stringUtils';

import { PERCENTAGE_BAND_COLORS } from '../constants';

export const TopLevelGroupsBreakdown = ({ shape }: { shape?: number[] }) => {
  const numTopLevelGroups = shape?.length ?? 0;
  const totalRunCount = shape?.reduce((a, b) => a + b, 0) ?? 0;

  if (!shape || numTopLevelGroups === 0 || totalRunCount === 0) {
    return (
      <Text variant="xs" color="tertiary">
        —
      </Text>
    );
  }

  const percentages = shape.map((count) =>
    ((count / totalRunCount) * 100).toFixed(1)
  );

  return (
    <Tooltip
      title={
        <div className="flex flex-col gap-2">
          {shape.map((count, index) => (
            <div key={index} className="flex items-center gap-2">
              <div
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '100%',
                  backgroundColor:
                    PERCENTAGE_BAND_COLORS[
                      index % PERCENTAGE_BAND_COLORS.length
                    ],
                }}
              ></div>
              <Text variant="xs">{xCount('run', count)}</Text>
            </div>
          ))}
        </div>
      }
    >
      <div className="flex flex-row items-center gap-2 rounded-sm border border-secondary p-2">
        <div className="flex min-h-[8px] w-[200px] flex-1 gap-[1px]">
          {percentages.map((percentage, index) => (
            <div
              key={index}
              style={{
                width: `${percentage}%`,
                backgroundColor:
                  PERCENTAGE_BAND_COLORS[index % PERCENTAGE_BAND_COLORS.length],
                minWidth: '2px',
                minHeight: '8px',
                borderRadius: '2px',
              }}
            />
          ))}
        </div>
        <Text variant="xs" weight="medium">
          {xCount('group', numTopLevelGroups)}
        </Text>
      </div>
    </Tooltip>
  );
};
